import React from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCompaniesQuery } from '../../slices/companyApiSlice';
import { setActiveCompany } from '../../slices/adminSlice';
import Loader from '../layout/Loader';

const CompanySelector = () => {
    const dispatch = useDispatch();
    const { activeCompany } = useSelector((state) => state.admin);
    const { data: companies, isLoading, error } = useGetCompaniesQuery();

    const handleChange = (e) => {
        const ruc = e.target.value;
        if (ruc === '') {
            dispatch(setActiveCompany(null));
        } else {
            const selected = companies.find((c) => c.ruc === ruc);
            dispatch(setActiveCompany(selected));
        }
    };

    if (isLoading) return <Loader />;
    if (error) return <div className="text-danger px-2 py-1 small">Error al cargar</div>;

    return (
        <div className="company-selector-wrapper" onClick={(e) => e.stopPropagation()}>
            <Form.Select
                size="sm"
                value={activeCompany?.ruc || ''}
                onChange={handleChange}
                className="company-selector-dropdown"
            >
                <option value="">Seleccionar Empresa...</option>
                {companies?.map((company) => (
                    <option key={company.ruc} value={company.ruc}>
                        {company.tradeName}
                    </option>
                ))}
            </Form.Select>
        </div>
    );
};

export default CompanySelector;
